import { SelectSearchField } from 'vetrf-ui';
import classNames from 'classnames';
import React, { useEffect, useState } from 'react';
import { CountryDictOption } from 'api/dict/params';
import { useUserDataContext } from 'components/UserDataContext/context';
import { useWatch } from 'react-hook-form';
import styles from './CountrySelect.module.scss';

type CountrySelectProps = {
  countryOptions: CountryDictOption[];
  fieldName: string;
  labelText?: string;
  multiple?: boolean;
};

export const CountrySelect = ({
  countryOptions,
  fieldName,
  labelText,
  multiple,
}: CountrySelectProps) => {
  const { userData } = useUserDataContext();
  const [styleResident, setStyleResident] = useState<boolean>(false);
  const [styleCountry, setStyleCountry] = useState<boolean>(false);
  const field = useWatch({ name: fieldName });

  useEffect(() => {
    if (field?.length) {
      if (field?.find((item: CountryDictOption) => item.guid === 'true' || item.guid === 'false')) {
        setStyleResident(true);
      } else {
        setStyleCountry(true);
      }
    } else {
      setStyleResident(false);
      setStyleCountry(false);
    }
  }, [field]);

  return (
    <SelectSearchField
      multiple={multiple}
      clearable
      fieldClassName="col-xs-12 selectpicker"
      labelClassName="col-xs-12 control-label"
      labelKey="name"
      valueKey="guid"
      labelText={labelText || 'ㅤ'}
      name={fieldName}
      placeholder=""
      options={countryOptions}
      className={classNames(
        userData && !styleResident && !styleCountry && styles.withBorder,
        styleResident && styles.resident,
        styleCountry && styles.country
      )}
    />
  );
};
